import * as React from "react"
import { translateCountryName } from "@ui-seeker/utils"

import { RetailerBlock } from "@components";


export default function retailerColumn() {
	return [{
		name: 'date', label: 'date',
		options: {
			display: 'excluded',
			customBodyRowRender: v => translateCountryName(v)
		}
	}, {
		name: 'country', label: 'Market',
		options: {
			display: 'excluded',
			customBodyRowRender: v => translateCountryName(v)
		}
	} , {
		name: "retailer", label: 'Retailer',
		options: {
			customBodyRowRender: (value, { country, siteURL, siteID, sellerID, date }) => <RetailerBlock 
				retailer={value}
				country={country}
				date={date}
				siteURL={siteURL}
			/>
		}
	}]
}
